import Filter from "../../components/Filter";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import DefaultPage from "../DefaultPage/DefaultPage";
import ContactCard from "../ContactPage/ContactCard";
import { useState } from "react";
import Loader from "../../components/Loader";
// import "./EmployeePage.css";

const EmployeePage = () => {
  const [filterParameters, setFilterParameters] = useState("");

  //stavy pro uchovani predchozi zvolene kategorie
  const [filterSearchTerm, setFilterSearchTerm] = useState("");
  const [filterSelectedCategory, setFilterSelectedCategory] = useState("");

  //fetch stránky (uvod)
  const {
    loading: loadingIntroduction,
    error: errorIntroduction,
    data: dataIntroduction,
  } = useFetch(`${config.api}/api/page-employee?populate=background`);

  //fetch oddeleni (pro filtr)
  // When you have multiple useFetch calls in the same component, you need to ensure that each set of destructured variables has unique names to avoid conflicts.
  // loading: loadingDepartments, error: errorDepartments, data: dataDepartments
  const {
    loading: loadingDepartments,
    error: errorDepartments,
    data: dataDepartments,
  } = useFetch(`${config.api}/api/departments`);
  //fetch kontaktu s populate pro jmena oddeleni pro filtr (pozor na public accessu u oddeleni)
  const { loading, error, data } = useFetch(
    `${config.api}/api/contacts?populate=departments${filterParameters}`
  );

  // možné stavy při/po fetchi
  if (loadingIntroduction) return <Loader />;
  if (errorIntroduction)
    return <DefaultPage message="Chyba při načítání úvodu" />;
  if (!dataIntroduction || !dataIntroduction.data)
    return <DefaultPage message="Chyba při načítání úvodu" />;
  if (loadingDepartments) return <Loader />;
  //prettier-ignore
  if (errorDepartments)return <DefaultPage message="Chyba při načítání oddělení" />;
  if (!dataDepartments || !dataDepartments.data)
    return <DefaultPage message="Chyba při načítání oddělení" />;
  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání kontaktů" />;
  if (!data || !data.data || data.data.length < 1)
    return <DefaultPage message="Žádní zamestnanci" />;

  //? console.log("zamestnanci", data);
  //? console.log("departments", dataDepartments);

  //metoda filtru - po submitu tlacitkem se předají stavy textu a kategorie do url pro strapi filtr
  const handleFilterSubmit = ({ searchTerm, selectedCategory }) => {
    let parametersURL = "&";
    if (searchTerm !== "") {
      const searchParts = searchTerm.trim().split(" ");

      if (searchParts.length === 1) {
        // budto jmeno nebo prijmeni
        parametersURL += `filters[$or][0][lastname][$contains]=${searchTerm}&filters[$or][1][firstname][$contains]=${searchTerm}`;
      } else if (searchParts.length >= 2) {
        // jmeno + prijmeni
        const firstNamePart = searchParts[0];
        const lastNamePart = searchParts[1];

        parametersURL += `filters[firstname][$contains]=${firstNamePart}&filters[lastname][$contains]=${lastNamePart}`;
      }
    }
    if (searchTerm !== "" && selectedCategory !== "") {
      parametersURL += `&`;
    }
    if (selectedCategory !== "") {
      parametersURL += `filters[departments][name][$eq]=${selectedCategory}`;
    }

    setFilterSearchTerm(searchTerm);
    setFilterSelectedCategory(selectedCategory);
    //?console.log(searchTerm, selectedCategory);
    setFilterParameters(parametersURL);
  };

  // rekonstrukce strapi dat kategorii do jednodussiho pole
  const departmentNames = dataDepartments.data.map((department) => ({
    id: department.id,
    category: department.name,
  }));

  //? test
  //? console.log(departmentNames);
  //? console.log(dataIntroduction);

  //změna titulku stránky v prohlížeči
  document.title = "Zaměstnanci";

  return (
    <div>
      <Navbar />
      <Introduction
        title={dataIntroduction.data.title}
        text={dataIntroduction.data.description}
        image={dataIntroduction.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background">
          <div className="row d-flex justify-content-center">
            <Filter
              onFilterSubmit={handleFilterSubmit}
              categories={departmentNames}
              selectedCategory={filterSelectedCategory}
              searchTerm={filterSearchTerm}
            />
            {/* neni potreba resit podminkou */}
            {data.data.map((employee) => (
              <div
                key={employee.id}
                className="col-10 col-md-6 col-lg-6 col-xl-4 p-2 p-lg-3"
              >
                <ContactCard
                  image=""
                  prefix={employee?.prefix ?? ""}
                  firstName={employee.firstname}
                  lastName={employee.lastname}
                  suffix={employee?.suffix ?? ""}
                  phone={employee.phone}
                  second_phone={employee.second_phone}
                  email={employee.email}
                  position={employee.position}
                  room={employee.room}
                  departments={employee?.departments ?? []}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default EmployeePage;

